export default new Vuex.Store({
    state: {
        favorites_list: [],
        friends_list: [],
        profile: null,
        theme: 'light'
    },
    mutations: {
        setProfile(state, profile) {
            state.profile = profile;
        },
        setTheme(state, theme) {
            state.theme = theme;
        },
        updateTheme(state, theme) {
            state.theme = theme;
            axios.post('user/theme/update', {theme:theme}).catch(error => {
                console.log('error =====', error);
            });
        },

        setFavoritesList(state, favorites_list) {
            state.favorites_list = favorites_list;
        },
        addFavorite(state, payload) {
            axios.post('favorites', {
                'match_id' : payload.match.id,
                'profile_id' : payload.profile.id
            }).then(response => {
                state.favorites_list.push(payload.match.id);
            }).catch(error => {
                console.log('Add FavoriteMatch : Error : ', error);
            });
        },
        removeFavorite(state, payload) {
            axios.get('favorites/'+payload.match.id+'/delete').then(response => {
                state.favorites_list.splice(state.favorites_list.indexOf(payload.match.id), 1);
                // state.favorites_count = state.favorites_count - 1;
            }).catch(error => {
                // console.log('RemoveFavoriteMatch : Error : ', error);
            });
        },

        setFriendsList(state, friends_list) {
            state.friends_list = friends_list;
        },
        addFriend(state, profile) {
            axios.post('friends', {
                'player_id' : profile.external_id
            }).then(response => {
                state.friends_list.push(profile.id);
            }).catch(error => {
                console.log('AddFriend : Error : ', error);
            });
        },
        removeFriend(state, profile) {
            axios.get('friends/' + profile.id + '/delete').then(response => {
                state.friends_list.splice(state.friends_list.indexOf(profile.id), 1);
            }).catch(error => {
                console.log('RemoveFriend : Error : ', error);
            });
        }
    },
    actions: {
        initStore(context) {
            axios.get('profile').then(response => {
                context.commit('setFavoritesList', response.data.favorites_list);
                context.commit('setFriendsList', response.data.friends_list);
                context.commit('setProfile', response.data.profile);
                context.commit('setTheme', response.data.theme);
            }).catch(error => {
                console.log('Could not initialize profile.');
            })
        }
    }
});
